import { render } from "./ConfigurationView.vue?vue&type=template&id=5df5e88c&scoped=true"
import script from "./ConfigurationView.vue?vue&type=script&lang=js"
export * from "./ConfigurationView.vue?vue&type=script&lang=js"

import "./ConfigurationView.vue?vue&type=style&index=0&id=5df5e88c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df5e88c"]])

export default __exports__